import type { ReactNode } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

/** `info`: a longer explanation kept out of the way behind an (i) icon next to the title. */
export function PageHeader({ title, subtitle, icon, actions, info }: { title: string; subtitle?: ReactNode; icon?: string; actions?: ReactNode; info?: ReactNode }) {
  return (
    <div className="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
      <div>
        <h1 className="h4 mb-0">
          {icon && <i className={`bi bi-${icon} me-2 text-primary`} aria-hidden />}
          {title}
          {info && (
            <OverlayTrigger
              trigger="click" rootClose placement="bottom"
              overlay={<Popover id="page-info"><Popover.Body className="small">{info}</Popover.Body></Popover>}
            >
              <button type="button" className="btn btn-link p-0 ms-2 align-baseline text-body-secondary" aria-label="About this screen"><i className="bi bi-info-circle fs-6" aria-hidden /></button>
            </OverlayTrigger>
          )}
        </h1>
        {subtitle && <div className="text-body-secondary small mt-1">{subtitle}</div>}
      </div>
      {actions && <div className="d-flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}
